<template>
<div class="alert alert-danger job-status-alert">
	<div class="d-flex justify-content-between align-items-center">
		<div>
			<i class="fa fa-trash"></i>
			This {{ jobLabel }} is deleted
		</div>

		<div>
			<button class="btn btn-primary" v-on:click="restore">
				Restore
			</button>
		</div>
	</div>
</div>
</template>
<script type="text/javascript">

export default {
	name: "JobDeleteAlert",
	props: [
		"jobApiResource"
	],
	computed: {
		jobLabel() {
			return this.storeLocation
		},
		storeLocation() {
			let map = {
				Service: "service",
				Job: "project"
			}

			return map[this.jobApiResource]
		}
	},
	methods: {
		restore() {
			let vm = this

			this.postData(this.jobApiResource+"/save",{id: this.$store[this.storeLocation].id, deleted: 0}).then(response => {
				if (response.success)
					vm.$store[vm.storeLocation].deleted = 0
			})
		}
	}
}

</script>